import { DocumentNode, gql } from "@apollo/client";

const REACT_BLOCK_PAGE_QUERY = `
    body {
        format
        processed
        value
    }
    nid
    promote
    status
    title
    url {
        path
        routed
    }
`;

const GET_FRONT_REACT_BLOCK_PAGES = () => {
    return gql`
        query Front {
            result:front {
               ${REACT_BLOCK_PAGE_QUERY}
            }
        }
    `;
};

export const GET_FRONT_REACT_BLOCK_PAGES_PARAMS = (): {
    query: DocumentNode;
    options: {
        skip: boolean;
    };
} => {
    return {
        query: GET_FRONT_REACT_BLOCK_PAGES(),
        options: {
            skip: false
        }
    };
};

const GET_REACT_BLOCK_PAGE_BY_ID = () => {
    return gql`
        query ReactBlockPageById($id: Int!){
            result:reactBlockPageById(id: $id) {
                ${REACT_BLOCK_PAGE_QUERY}
            }
        }
    `;
};

export const GET_REACT_BLOCK_PAGE_BY_ID_PARAMS = (
    id?: number
): {
    query: DocumentNode;
    options: {
        skip: boolean;
        variables: {
            id: number;
        };
    };
} => {
    return {
        query: GET_REACT_BLOCK_PAGE_BY_ID(),
        options: {
            skip: id != null ? false : true,
            variables: {
                id
            }
        }
    };
};

export const GET_REACT_BLOCK_PAGE_PARAMS = (
    front?: boolean,
    id?: string
): {
    query: DocumentNode;
    options: {
        skip: boolean;
        variables: {
            id?: number;
        };
    };
} => {
    return {
        query: front === true ? GET_FRONT_REACT_BLOCK_PAGES() : GET_REACT_BLOCK_PAGE_BY_ID(),
        options: {
            skip: front === true || (id != null && id.trim() !== "") ? false : true,
            variables: {
                id: id != null && id.trim() !== "" ? parseInt(id) : undefined
            }
        }
    };
};
